export enum Gender {
  male = 'Male',
  female = 'Female',
  nonBinary = 'Non-binary',
  selfDescribe = 'Prefer to self describe',
  preferNotToSay = 'Prefer not to say',
}
